<template>
  <Panel
    :is-load-data="isLoading"
    :is-loading="isLoading"
    :variant="panelVariant"
  >
    <router-view></router-view>
  </Panel>
</template>

<script>
import Panel from '@/components/atoms/Panel';
import isLoadingMixin from '@/mixins/isLoading';
import { mapGetters, mapState } from 'vuex';
import store from '@/store';

export default {
  name: 'TournamentRegistration',
  components: {
    Panel,
  },
  mixins: [isLoadingMixin],
  data() {
    return {};
  },
  computed: {
    ...mapState('current', ['account']),
    ...mapGetters(['registrationFields', 'registrationTournament']),
    playerType() {
      return this.$lodash.get(this, 'registrationTournament.playerType', '');
    },
    panelVariant() {
      // return this.$route.name === 'tournamentRegistrationWithNewTeam'
      //   ? 'transparent'
      //   : undefined;
      return 'transparent';
    },
  },
  beforeRouteEnter(to, from, next) {
    const id = to.params.tournamentID;

    Promise.all([
      store.dispatch('getTournament', id).then(data => {
        store.commit('setRegistrationTournament', data);
      }),
      store.dispatch('fetchTournamentCustomFields', { id }).then(data => {
        store.commit('setRegistrationFields', data);
      }),
    ])
      .then(next)
      .catch(error => {
        store.dispatch('errorNotify', error);
      });
  },
};
</script>
